export default [
  {
    path: '/templates',
    name: 'templates',
    component: () =>
      import(/* webpackChunkName: "templates" */
        /* webpackMode: "lazy" */
        `./views/TemplateSettings.vue`)
  },
  {
    path: '/pages',
    name: 'pages',
    component: () =>
      import(/* webpackChunkName: "pages" */
        /* webpackMode: "lazy" */
        `./views/PageList.vue`)
  },
  {
    path: '/pages/__',
    name: 'new-page',
    component: () =>
      import(/* webpackChunkName: "pages" */
        /* webpackMode: "lazy" */
        `./views/PageSingle.vue`)
  },
  {
    path: '/pages/:id',
    name: 'single-page',
    component: () =>
      import(/* webpackChunkName: "pages" */
        /* webpackMode: "lazy" */
        `./views/PageSingle.vue`)
  },
  {
    path: '/components',
    name: 'components',
    component: () =>
      import(/* webpackChunkName: "components" */
        /* webpackMode: "lazy" */
        `./views/ComponentList.vue`)
  },
  {
    path: '/components/__',
    name: 'new-component',
    component: () =>
      import(/* webpackChunkName: "components" */
        /* webpackMode: "lazy" */
        `./views/ComponentSingle.vue`)
  },
  {
    path: '/components/:id',
    name: 'single-component',
    component: () =>
      import(/* webpackChunkName: "components" */
        /* webpackMode: "lazy" */
        `./views/ComponentSingle.vue`)
  }
]
